import { LOG } from './types';
const colors = {
  DEBUG: 'blue',
  INFO: 'green',
  WARN: 'orange',
  ERROR: 'red',
  FATAL: 'red'
};
const _log = (level, fields, msg) => {
  const _level = fields.level || level.toUpperCase();
  try {
    window.console.groupCollapsed('%s %c %s%s: ', new Date().toTimeString(), `color: ${colors[_level]}`, _level, fields.namespace && typeof fields.namespace === 'string' ? ` [${fields.namespace}]` : '', msg);
    window.console.log(fields);
    window.console.groupEnd();
  } catch (e) {
    window.console.log('%s  %s%s: %s', new Date().toTimeString(), _level, fields.namespace && typeof fields.namespace === 'string' ? ` ${fields.namespace}` : '', msg, fields);
  }
};
const _defaultLogger = {
  debug: (...args) => _log('debug', ...args),
  info: (...args) => _log('info', ...args),
  warn: (...args) => _log('warn', ...args),
  error: (...args) => _log('error', ...args),
  fatal: (...args) => _log('error', ...args)
};
export function createAppLogger(options) {
  return () => next => action => {
    if (action.type !== LOG) {
      return next(action);
    }
    const level = action.level;
    const cleanOptions = {
      logger: _defaultLogger,
      ...options
    };
    const {
      logger
    } = cleanOptions;
    if (logger.fields && logger.fields.namespace) {
      action.fields.namespace = [logger.fields.namespace, action.fields.namespace].join('/');
    }
    try {
      logger[level](action.fields, action.message);
    } catch (e) {
      logger.debug(`Invalid log level "${level}"`);
      action.fields = {
        ...action.fields,
        level
      };
      logger.info(action.fields, action.message);
    }
    return null;
  };
}